import React from "react";

import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import FireBase from "../assets/firebase.png";
import GitHub from "../assets/github.png";
import Tailwind from "../assets/tailwind.png";
import Bootstrap from "../assets/bootstrap.png";
import Mongo from "../assets/mongo.png";
import Git from "../assets/Git.png";
import jquery from "../assets/jq.png";
import redux from "../assets/redux.png";
import webpack from "../assets/webpack.png";
import storybook from "../assets/storybook.png";

const Skills = () => {
    return (
        // <div name='about' className=' w-full h-screen bg-[#0a192f] text-gray-300 px-4'>
        //     <div className='flex flex-col justify-center items-center w-full h-full'></div>
        <div
            name="skills"
            className=" w-full h-full  bg-[#0a192f]  text-gray-300 px-4  "
        >
            {/* container */}

            <div className="max-w-[1000px] mx-auto  p-4 flex flex-col justify-center w-full h-full">
                <div className="mt-20">
                    <p className="text-4xl font-bold inline border-b-4 border-pink-600 ">
                        Skills
                    </p>
                    <p className="py-4">These are the technologies I've worked with</p>
                </div>

                <div className="w-full h-full  grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8 `">
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={HTML} alt="HTML icon" />
                        <p className="my-4">HTML</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={CSS} alt="CSS icon" />
                        <p className="my-4">CSS</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={Bootstrap} alt="Bootstrap" />
                        <p className="my-4">Bootstrap</p>
                    </div>
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={Tailwind} alt="Tailwind icon" />
                        <p className="my-4">Tailwind</p>
                    </div>
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img
                            className="w-20 mx-auto"
                            src={JavaScript}
                            alt="JavaScripticon"
                        />
                        <p className="my-4">JavaScript</p>
                    </div>
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={jquery} alt="JavaScripticon" />
                        <p className="my-4">jQuery</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={ReactImg} alt="ReactImg icon" />
                        <p className="my-4">React.js</p>
                    </div>
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={Mongo} alt="Mongo icon" />
                        <p className="my-4">Mongo</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={Node} alt="Node icon" />
                        <p className="my-4">Node</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={webpack} alt="webpack icon" />
                        <p className="my-4">Webpack</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img
                            className="w-20 mx-auto"
                            src={storybook}
                            alt="storybook icon"
                        />
                        <p className="my-4">StoryBook</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={redux} alt="redux icon" />
                        <p className="my-4">Redux-toolkit</p>
                    </div>
                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={Git} alt="Git icon" />
                        <p className="my-4">Git</p>
                    </div>

                    <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-700">
                        <img className="w-20 mx-auto" src={GitHub} alt="GitHub icon" />
                        <p className="my-4">GitHub</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
